import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export var EmailAddressTypeInline;
(function (EmailAddressTypeInline) {
    EmailAddressTypeInline["SCREENSHOT"] = "SCREENSHOT";
    EmailAddressTypeInline["REPORT"] = "REPORT";
    EmailAddressTypeInline["INVOICE"] = "INVOICE";
    EmailAddressTypeInline["CREATIVE"] = "CREATIVE";
    EmailAddressTypeInline["SUGGESTION"] = "SUGGESTION";
})(EmailAddressTypeInline || (EmailAddressTypeInline = {}));
export const fetchEmailAddressesByAccountIdAndContactId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.emailAddressType === undefined) {
        throw new Error('Missing required parameter: emailAddressType');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/campaigns/email-addresses/by-account';
    const pathInternal = '/api/campaigns/email-addresses/by-account';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.emailAddressType !== undefined) {
        urlParams.append('emailAddressType', params.emailAddressType.toString());
    }
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    {
        const value = queryDefaults === false ? params.contactId : (params.contactId ?? queryDefaults?.['contactId']);
        if (value !== undefined) {
            urlParams.append('contactId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
fetchEmailAddressesByAccountIdAndContactId.paramsOrder = [{ type: 'parameters' }];
/** Returns accounts */ export const getBatchAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/batch/accounts';
    const pathInternal = '/api/batch/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns digital accounts */ export const getBatchDigitalAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/batch/accounts/digital';
    const pathInternal = '/api/batch/accounts/digital';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchDigitalAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns contacts */ export const getBatchContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/batch/contacts';
    const pathInternal = '/api/batch/contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchContacts.paramsOrder = [{ type: 'parameters' }];
/** Returns industries */ export const getBatchIndustries = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/batch/industries';
    const pathInternal = '/api/batch/industries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchIndustries.paramsOrder = [{ type: 'parameters' }];
/** Returns accounts for reporting */ export const getReportingAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/reporting/accounts';
    const pathInternal = '/api/reporting/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns contacts for reporting */ export const getReportingContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/reporting/contacts';
    const pathInternal = '/api/reporting/contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingContacts.paramsOrder = [{ type: 'parameters' }];
/** Get account by ID */ export const getAccountById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/accounts/single-by-id';
    const pathInternal = '/api/accounts/single-by-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountById.paramsOrder = [{ type: 'parameters' }];
/** Returns relevant accounts by name */ export const getRelevantAccountsByName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-crm/account/by-name';
    const pathInternal = '/api/account/by-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRelevantAccountsByName.paramsOrder = [{ type: 'parameters' }];
/** Get detailed account by ID */ export const getDetailedAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/accounts/detailed';
    const pathInternal = '/api/accounts/detailed';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDetailedAccount.paramsOrder = [{ type: 'parameters' }];
export const addContactToAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/accounts/{accountId}/contact'.replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/accounts/{accountId}/contact'.replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addContactToAccount.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Update contact active state */ export const updateContactActiveState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.isActive === undefined) {
        throw new Error('Missing required parameter: isActive');
    }
    const path = '/api/ws-crm/contacts/{id}/active'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/contacts/{id}/active'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.isActive !== undefined) {
        urlParams.append('isActive', params.isActive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateContactActiveState.paramsOrder = [{ type: 'parameters' }];
/** Get amounts by account grouped by year */ export const getAccountYearlyAmounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/{id}/yearly-amounts'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/{id}/yearly-amounts'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.minYear : (params.minYear ?? queryDefaults?.['minYear']);
        if (value !== undefined) {
            urlParams.append('minYear', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.maxYear : (params.maxYear ?? queryDefaults?.['maxYear']);
        if (value !== undefined) {
            urlParams.append('maxYear', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountYearlyAmounts.paramsOrder = [{ type: 'parameters' }];
/** Returns all owned accounts */ export const getAllOwnedAccountsShort = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/all-accounts/short';
    const pathInternal = '/api/all-accounts/short';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.role : (params.role ?? queryDefaults?.['role']);
        if (value !== undefined) {
            urlParams.append('role', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.internal : (params.internal ?? queryDefaults?.['internal']);
        if (value !== undefined) {
            urlParams.append('internal', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedAccountId
            : (params.includedAccountId ?? queryDefaults?.['includedAccountId']);
        if (value !== undefined) {
            urlParams.append('includedAccountId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllOwnedAccountsShort.paramsOrder = [{ type: 'parameters' }];
/** Returns all accounts */ export const getAllAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/all-accounts';
    const pathInternal = '/api/all-accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.role : (params.role ?? queryDefaults?.['role']);
        if (value !== undefined) {
            urlParams.append('role', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedAccountId
            : (params.includedAccountId ?? queryDefaults?.['includedAccountId']);
        if (value !== undefined) {
            urlParams.append('includedAccountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns all accounts */ export const getAllAccountsWithNet4 = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/all-accounts/with-n4';
    const pathInternal = '/api/all-accounts/with-n4';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.industryId : (params.industryId ?? queryDefaults?.['industryId']);
        if (value !== undefined) {
            urlParams.append('industryId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.salesContactId : (params.salesContactId ?? queryDefaults?.['salesContactId']);
        if (value !== undefined) {
            urlParams.append('salesContactId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.labelIds : (params.labelIds ?? queryDefaults?.['labelIds']);
        if (value !== undefined) {
            urlParams.append('labelIds', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.roles : (params.roles ?? queryDefaults?.['roles']);
        if (value !== undefined) {
            urlParams.append('roles', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.active : (params.active ?? queryDefaults?.['active']);
        if (value !== undefined) {
            urlParams.append('active', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.hasActiveRevenue
            : (params.hasActiveRevenue ?? queryDefaults?.['hasActiveRevenue']);
        if (value !== undefined) {
            urlParams.append('hasActiveRevenue', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.accountTypeId : (params.accountTypeId ?? queryDefaults?.['accountTypeId']);
        if (value !== undefined) {
            urlParams.append('accountTypeId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAccountsWithNet4.paramsOrder = [{ type: 'parameters' }];
/** Returns all accouts with role BROKER, AGENCY, ADVERTISER by input ID list. */ export const getAccountListByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIdList === undefined) {
        throw new Error('Missing required body: accountIdList');
    }
    const path = '/api/ws-crm/accounts-by-ids';
    const pathInternal = '/api/accounts-by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIdList !== undefined) {
        body = params.accountIdList;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountListByIds.paramsOrder = [{ type: 'body', paramName: 'accountIdList' }];
/** Returns all accounts with role either BROKER, AGENCY or ADVERTISER. */ export const getAccountList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.role : (params.role ?? queryDefaults?.['role']);
        if (value !== undefined) {
            urlParams.append('role', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedAccountId
            : (params.includedAccountId ?? queryDefaults?.['includedAccountId']);
        if (value !== undefined) {
            urlParams.append('includedAccountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isActive : (params.isActive ?? queryDefaults?.['isActive']);
        if (value !== undefined) {
            urlParams.append('isActive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountList.paramsOrder = [{ type: 'parameters' }];
export const createAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contact === undefined) {
        throw new Error('Missing required body: contact');
    }
    const path = '/api/ws-crm/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contact !== undefined) {
        body = params.contact;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAccount.paramsOrder = [{ type: 'body', paramName: 'contact' }];
/** Temporal endpoint to create account while sales users migration to sales contact */ export const createAccountForMigration = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contact === undefined) {
        throw new Error('Missing required body: contact');
    }
    const path = '/api/ws-crm/accounts/migration';
    const pathInternal = '/api/accounts/migration';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contact !== undefined) {
        body = params.contact;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAccountForMigration.paramsOrder = [{ type: 'body', paramName: 'contact' }];
export const createSelfbookedAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contact === undefined) {
        throw new Error('Missing required body: contact');
    }
    const path = '/api/ws-crm/accounts/self-booked';
    const pathInternal = '/api/accounts/self-booked';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contact !== undefined) {
        body = params.contact;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSelfbookedAccount.paramsOrder = [{ type: 'body', paramName: 'contact' }];
export const updateSelfbookedAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/self-booked/{id}';
    const pathInternal = '/api/accounts/self-booked/{id}';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    if (params.id !== undefined) {
        urlParams.append('id', params.id.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSelfbookedAccount.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns all accouts with role ADVERTISER. */ export const getAdvertiserAccountList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/accounts/advertisers';
    const pathInternal = '/api/accounts/advertisers';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdvertiserAccountList.paramsOrder = [{ type: 'parameters' }];
export const updateAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contact === undefined) {
        throw new Error('Missing required body: contact');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/accounts/{accountId}'.replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/accounts/{accountId}'.replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contact !== undefined) {
        body = params.contact;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAccount.paramsOrder = [{ type: 'body', paramName: 'contact' }, { type: 'parameters' }];
/** Returns a list of account types */ export const getAccountTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/account-types';
    const pathInternal = '/api/account-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountTypes.paramsOrder = [{ type: 'parameters' }];
/** Creates an account type */ export const createAccountType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-crm/account-types';
    const pathInternal = '/api/account-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAccountType.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Returns paginated list of account types */ export const getPaginatedAccountTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/account-types/paginated';
    const pathInternal = '/api/account-types/paginated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedAccountTypes.paramsOrder = [{ type: 'parameters' }];
/** Get account type by ID */ export const getAccountTypeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/account-types/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/account-types/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountTypeById.paramsOrder = [{ type: 'parameters' }];
/** Updates an account type */ export const updateAccountType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/account-types/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/account-types/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAccountType.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Deletes an account type */ export const deleteAccountType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/account-types/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/account-types/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteAccountType.paramsOrder = [{ type: 'parameters' }];
/** Returns the locked-fields configuration for the company, one entry per entity type */ export const getLockedFieldsConfigs = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/companies/locked-fields';
    const pathInternal = '/api/companies/locked-fields';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLockedFieldsConfigs.paramsOrder = [];
/** Creates or updates the locked-fields configuration for a single entity type */ export const upsertLockedFieldsConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-crm/companies/locked-fields';
    const pathInternal = '/api/companies/locked-fields';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
upsertLockedFieldsConfig.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Returns the locked-fields configuration for the company by entity type */ export const getLockedFieldsConfigByType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-crm/locked-fields/{type}'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/locked-fields/{type}'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLockedFieldsConfigByType.paramsOrder = [{ type: 'parameters' }];
/** Returns the catalog of lockable field names for the given entity type */ export const getAvailableLockedFields = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-crm/locked-fields/available/{type}'.replace('{type}', params.type?.toString());
    const pathInternal = '/api/locked-fields/available/{type}'.replace('{type}', params.type?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAvailableLockedFields.paramsOrder = [{ type: 'parameters' }];
/** Returns the entity types that do not yet have a locked-fields configuration */ export const getAvailableLockedEntityTypes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/locked-fields/available-types';
    const pathInternal = '/api/locked-fields/available-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAvailableLockedEntityTypes.paramsOrder = [];
/** Returns a list of industries */ export const getIndustries = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/accounts/industries';
    const pathInternal = '/api/accounts/industries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getIndustries.paramsOrder = [{ type: 'parameters' }];
/** Creates an industry */ export const createIndustry = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-crm/accounts/industries';
    const pathInternal = '/api/accounts/industries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createIndustry.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get industry by ID */ export const getIndustryById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/industries/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/industries/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getIndustryById.paramsOrder = [{ type: 'parameters' }];
/** Updates an industry */ export const updateIndustry = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/industries/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/industries/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateIndustry.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Delete an industry */ export const deleteIndustry = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/industries/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/industries/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.replacementId : (params.replacementId ?? queryDefaults?.['replacementId']);
        if (value !== undefined) {
            urlParams.append('replacementId', value.toString());
        }
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteIndustry.paramsOrder = [{ type: 'parameters' }];
/** Returns list of accounts with excluded websites */ export const getAccountsWithExcludedWebsite = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-crm/accounts/excluded-website/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/accounts/excluded-website/{websiteId}'.replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountsWithExcludedWebsite.paramsOrder = [{ type: 'parameters' }];
export const addWebsiteExclusionForAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-crm/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
addWebsiteExclusionForAccount.paramsOrder = [{ type: 'parameters' }];
/** Remove website from account exclusions */ export const removeWebsiteExclusionForAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.websiteId === undefined) {
        throw new Error('Missing required parameter: websiteId');
    }
    const path = '/api/ws-crm/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    const pathInternal = '/api/accounts/{accountId}/exclude-website/{websiteId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{websiteId}', params.websiteId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeWebsiteExclusionForAccount.paramsOrder = [{ type: 'parameters' }];
/** Enable account */ export const enableAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/{id}/enable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/{id}/enable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
enableAccount.paramsOrder = [{ type: 'parameters' }];
/** Disable account */ export const disableAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/accounts/{id}/disable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/{id}/disable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
disableAccount.paramsOrder = [{ type: 'parameters' }];
export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-crm/accounts/{accountId}/replace-and-remove'.replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/accounts/{accountId}/replace-and-remove'.replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export const removeCompanyDiscountFromAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.companyDiscountId === undefined) {
        throw new Error('Missing required parameter: companyDiscountId');
    }
    const path = '/api/ws-crm/accounts/company-discount/{companyDiscountId}/remove'.replace('{companyDiscountId}', params.companyDiscountId?.toString());
    const pathInternal = '/api/accounts/company-discount/{companyDiscountId}/remove'.replace('{companyDiscountId}', params.companyDiscountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeCompanyDiscountFromAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns a list of account roles */ export const getAccountRoles = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/accounts/roles';
    const pathInternal = '/api/accounts/roles';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountRoles.paramsOrder = [];
/** Returns a list of language codes */ export const getLanguages = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/languages';
    const pathInternal = '/api/languages';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getLanguages.paramsOrder = [];
/** Returns a list of country codes */ export const getCountries = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/countries';
    const pathInternal = '/api/countries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCountries.paramsOrder = [];
/** Get account by ID */ export const getAccountShortById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/accounts/short/single-by-id';
    const pathInternal = '/api/accounts/short/single-by-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountShortById.paramsOrder = [{ type: 'parameters' }];
/** All possible identifier types for account */ export const getExternalIdentifierTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountContext === undefined) {
        throw new Error('Missing required body: accountContext');
    }
    const path = '/api/ws-crm/accounts/external-identifier-types';
    const pathInternal = '/api/accounts/external-identifier-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountContext !== undefined) {
        body = params.accountContext;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getExternalIdentifierTypes.paramsOrder = [{ type: 'body', paramName: 'accountContext' }];
/** Returns a list of genders */ export const getGenders = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/genders';
    const pathInternal = '/api/genders';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getGenders.paramsOrder = [];
/** Returns a list of forms of communication */ export const getContactRoles = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/contacts/roles';
    const pathInternal = '/api/contacts/roles';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactRoles.paramsOrder = [];
/** Returns all contacts by accounts */ export const getContactsByCompanyAndRole = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.role === undefined) {
        throw new Error('Missing required parameter: role');
    }
    const path = '/api/ws-crm/contacts/by-company-and-role';
    const pathInternal = '/api/contacts/by-company-and-role';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.role !== undefined) {
        urlParams.append('role', params.role.toString());
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsByCompanyAndRole.paramsOrder = [{ type: 'parameters' }];
/** Returns all contacts by company */ export const getCompanyContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/contacts/by-company';
    const pathInternal = '/api/contacts/by-company';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCompanyContacts.paramsOrder = [{ type: 'parameters' }];
/** Returns all contacts by company`s accounts */ export const getContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/contacts';
    const pathInternal = '/api/contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.activeAccount : (params.activeAccount ?? queryDefaults?.['activeAccount']);
        if (value !== undefined) {
            urlParams.append('activeAccount', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContacts.paramsOrder = [{ type: 'parameters' }];
/** Creates or updates contact for existing account */ export const createOrUpdateContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-crm/contacts';
    const pathInternal = '/api/contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateContact.paramsOrder = [{ type: 'body', paramName: 'body' }, { type: 'parameters' }];
/** Returns owned contacts by company`s accounts */ export const getOwnedContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/contacts/owned';
    const pathInternal = '/api/contacts/owned';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getOwnedContacts.paramsOrder = [{ type: 'parameters' }];
/** Returns all contacts by accounts */ export const getContactsByAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIdList === undefined) {
        throw new Error('Missing required body: accountIdList');
    }
    const path = '/api/ws-crm/contacts/by-accounts';
    const pathInternal = '/api/contacts/by-accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIdList !== undefined) {
        body = params.accountIdList;
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsByAccounts.paramsOrder = [{ type: 'body', paramName: 'accountIdList' }, { type: 'parameters' }];
/** Returns contacts from parent accounts. For each input account, if it is a child (Address Account), contacts are resolved from its parent (Business Account); otherwise from the account itself. */ export const getContactsByAccountIdsIncludeParent = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIdList === undefined) {
        throw new Error('Missing required body: accountIdList');
    }
    const path = '/api/ws-crm/contacts/by-accounts/include-parent';
    const pathInternal = '/api/contacts/by-accounts/include-parent';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIdList !== undefined) {
        body = params.accountIdList;
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsByAccountIdsIncludeParent.paramsOrder = [
    { type: 'body', paramName: 'accountIdList' },
    { type: 'parameters' },
];
/** Returns all contacts by account */ export const getContactByAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/contacts/by-accountId';
    const pathInternal = '/api/contacts/by-accountId';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.active : (params.active ?? queryDefaults?.['active']);
        if (value !== undefined) {
            urlParams.append('active', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactByAccountId.paramsOrder = [{ type: 'parameters' }];
/** Returns all contacts paginated by account */ export const getPaginatedContactByAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/contacts/by-accountId/paginated';
    const pathInternal = '/api/contacts/by-accountId/paginated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedContactByAccountId.paramsOrder = [{ type: 'parameters' }];
/** Returns contact by id */ export const getContactById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/contacts/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/contacts/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactById.paramsOrder = [{ type: 'parameters' }];
/** Returns contacts by ids */ export const getContactsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-crm/contacts/by-ids';
    const pathInternal = '/api/contacts/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
/** Returns all contacts by email */ export const getContactsByEmail = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/ws-crm/contacts/by-email';
    const pathInternal = '/api/contacts/by-email';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsByEmail.paramsOrder = [{ type: 'parameters' }];
/** Creates contact and account based on contact info */ export const createContactWithAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contactWithAccountForm === undefined) {
        throw new Error('Missing required body: contactWithAccountForm');
    }
    const path = '/api/ws-crm/contacts/create-with-account';
    const pathInternal = '/api/contacts/create-with-account';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactWithAccountForm !== undefined) {
        body = params.contactWithAccountForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createContactWithAccount.paramsOrder = [{ type: 'body', paramName: 'contactWithAccountForm' }];
/** Returns all contacts with accounts */ export const getContactsWithAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/contacts/with-accounts';
    const pathInternal = '/api/contacts/with-accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsWithAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns all contacts by email and name */ export const getContactByEmailOrNameLike = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/contacts/by-email-or-name-like';
    const pathInternal = '/api/contacts/by-email-or-name-like';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.emailFilter : (params.emailFilter ?? queryDefaults?.['emailFilter']);
        if (value !== undefined) {
            urlParams.append('emailFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameFilter : (params.nameFilter ?? queryDefaults?.['nameFilter']);
        if (value !== undefined) {
            urlParams.append('nameFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactByEmailOrNameLike.paramsOrder = [{ type: 'parameters' }];
/** Enable contact */ export const enableContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/contacts/{id}/enable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/contacts/{id}/enable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
enableContact.paramsOrder = [{ type: 'parameters' }];
/** Disable contact */ export const disableContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/contacts/{id}/disable'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/contacts/{id}/disable'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
disableContact.paramsOrder = [{ type: 'parameters' }];
/** Update contact */ export const updateContactEmail = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.email === undefined) {
        throw new Error('Missing required parameter: email');
    }
    const path = '/api/ws-crm/contacts/{id}/email'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/contacts/{id}/email'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.email !== undefined) {
        urlParams.append('email', params.email.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateContactEmail.paramsOrder = [{ type: 'parameters' }];
export const checkIfLabelIsUsed = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.labelId === undefined) {
        throw new Error('Missing required parameter: labelId');
    }
    const path = '/api/ws-crm/labels/{labelId}/isUsed'.replace('{labelId}', params.labelId?.toString());
    const pathInternal = '/api/labels/{labelId}/isUsed'.replace('{labelId}', params.labelId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkIfLabelIsUsed.paramsOrder = [{ type: 'parameters' }];
/** Returns recipient mails recommendations. */ export const getRecipientMailsRecommendations = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-crm/campaigns/{campaignId}/comments/recipients/mails/recommendations'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/comments/recipients/mails/recommendations'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getRecipientMailsRecommendations.paramsOrder = [{ type: 'parameters' }];
/** Get xandr advertiser id by an account */ export const getXandrAdvertiserIdByAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-crm/campaign-position/{accountId}/add-xandr-advertiser-id'.replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/campaign-position/{accountId}/add-xandr-advertiser-id'.replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getXandrAdvertiserIdByAccount.paramsOrder = [{ type: 'parameters' }];
/** Add xandr advertiser id to a account */ export const addXandrAdvertiserIdToAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.xandrAdvertiserId === undefined) {
        throw new Error('Missing required parameter: xandrAdvertiserId');
    }
    const path = '/api/ws-crm/campaign-position/{accountId}/add-xandr-advertiser-id/{xandrAdvertiserId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{xandrAdvertiserId}', params.xandrAdvertiserId?.toString());
    const pathInternal = '/api/campaign-position/{accountId}/add-xandr-advertiser-id/{xandrAdvertiserId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{xandrAdvertiserId}', params.xandrAdvertiserId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addXandrAdvertiserIdToAccount.paramsOrder = [{ type: 'parameters' }];
/** Add gam advertiser id to a account */ export const addGamAdvertiserIdToAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.gamAdvertiserId === undefined) {
        throw new Error('Missing required parameter: gamAdvertiserId');
    }
    const path = '/api/ws-crm/campaign-position/{accountId}/add-gam-advertiser-id/{gamAdvertiserId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{gamAdvertiserId}', params.gamAdvertiserId?.toString());
    const pathInternal = '/api/campaign-position/{accountId}/add-gam-advertiser-id/{gamAdvertiserId}'
        .replace('{accountId}', params.accountId?.toString())
        .replace('{gamAdvertiserId}', params.gamAdvertiserId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addGamAdvertiserIdToAccount.paramsOrder = [{ type: 'parameters' }];
/** Returns company discounts */ export const getDiscounts = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/discounts';
    const pathInternal = '/api/discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDiscounts.paramsOrder = [];
/** Create or update list of Discount and there DiscountDetails */ export const upsertDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.discountList === undefined) {
        throw new Error('Missing required body: discountList');
    }
    const path = '/api/ws-crm/discounts';
    const pathInternal = '/api/discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.discountList !== undefined) {
        body = params.discountList;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
upsertDiscounts.paramsOrder = [{ type: 'body', paramName: 'discountList' }];
/** Create account records using csv file */ export const importAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.importId === undefined) {
        throw new Error('Missing required parameter: importId');
    }
    const path = '/api/ws-crm/import/account';
    const pathInternal = '/api/import/account';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.importId !== undefined) {
        urlParams.append('importId', params.importId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
importAccounts.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getAccountImportTemplate = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/import/account/template';
    const pathInternal = '/api/import/account/template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
getAccountImportTemplate.paramsOrder = [];
/** Create contact records using csv file */ export const importContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.importId === undefined) {
        throw new Error('Missing required parameter: importId');
    }
    const path = '/api/ws-crm/imports/contact';
    const pathInternal = '/api/imports/contact';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.importId !== undefined) {
        urlParams.append('importId', params.importId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
importContacts.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getContactImportTemplate = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/import/contact/template';
    const pathInternal = '/api/import/contact/template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
getContactImportTemplate.paramsOrder = [];
/** Returns admediums for discounts */ export const getDiscountAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/account/discount/admediums';
    const pathInternal = '/api/account/discount/admediums';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDiscountAdMediums.paramsOrder = [{ type: 'parameters' }];
/** Returns comments */ export const getComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.creatorId : (params.creatorId ?? queryDefaults?.['creatorId']);
        if (value !== undefined) {
            urlParams.append('creatorId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.contactId : (params.contactId ?? queryDefaults?.['contactId']);
        if (value !== undefined) {
            urlParams.append('contactId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getComments.paramsOrder = [{ type: 'parameters' }];
/** Create comment */ export const createComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-crm/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createComment.paramsOrder = [{ type: 'body', paramName: 'comment' }];
/** Update comment */ export const updateComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-crm/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateComment.paramsOrder = [{ type: 'body', paramName: 'comment' }, { type: 'parameters' }];
/** delete comment */ export const deleteComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-crm/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteComment.paramsOrder = [{ type: 'parameters' }];
export const getReferenceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/reference-lists';
    const pathInternal = '/api/reference-lists';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameFilter : (params.nameFilter ?? queryDefaults?.['nameFilter']);
        if (value !== undefined) {
            urlParams.append('nameFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReferenceLists.paramsOrder = [{ type: 'parameters' }];
export const createReferenceList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.referenceListForm === undefined) {
        throw new Error('Missing required body: referenceListForm');
    }
    const path = '/api/ws-crm/reference-lists';
    const pathInternal = '/api/reference-lists';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.referenceListForm !== undefined) {
        body = params.referenceListForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createReferenceList.paramsOrder = [{ type: 'body', paramName: 'referenceListForm' }];
export const getReferenceList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-crm/reference-lists/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/reference-lists/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReferenceList.paramsOrder = [{ type: 'parameters' }];
export const updateReferenceList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.referenceListForm === undefined) {
        throw new Error('Missing required body: referenceListForm');
    }
    const path = '/api/ws-crm/reference-lists/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/reference-lists/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.referenceListForm !== undefined) {
        body = params.referenceListForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateReferenceList.paramsOrder = [{ type: 'body', paramName: 'referenceListForm' }, { type: 'parameters' }];
/** Set ReferenceList active state */ export const setReferenceListActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-crm/reference-lists/{id}/active/{active}'
        .replace('{id}', params.id?.toString())
        .replace('{active}', params.active?.toString());
    const pathInternal = '/api/reference-lists/{id}/active/{active}'
        .replace('{id}', params.id?.toString())
        .replace('{active}', params.active?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setReferenceListActive.paramsOrder = [{ type: 'parameters' }];
export const getExternalReference = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.campaignPositionType === undefined) {
        throw new Error('Missing required parameter: campaignPositionType');
    }
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    if (params.positionEndDate === undefined) {
        throw new Error('Missing required parameter: positionEndDate');
    }
    const path = '/api/ws-crm/reference-lists/external-reference';
    const pathInternal = '/api/reference-lists/external-reference';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.campaignPositionType !== undefined) {
        urlParams.append('campaignPositionType', params.campaignPositionType.toString());
    }
    if (params.adMediumId !== undefined) {
        urlParams.append('adMediumId', params.adMediumId.toString());
    }
    if (params.positionEndDate !== undefined) {
        urlParams.append('positionEndDate', params.positionEndDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getExternalReference.paramsOrder = [{ type: 'parameters' }];
/** Get list of feature flags */ export const getFeatureToggles = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-crm/feature-toggles';
    const pathInternal = '/api/feature-toggles';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFeatureToggles.paramsOrder = [];
export * from './types';
export * from './constants';
